import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "title"]

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href")
    const title = event.currentTarget.dataset.legalModalTitle || ""
    if (!url) return

    this.titleTarget.textContent = title
    this.contentTarget.innerHTML = '<div class="flex justify-center py-12"><div class="animate-spin h-8 w-8 border-4 border-brand-500 border-t-transparent rounded-full"></div></div>'
    this.modalTarget.classList.remove("hidden")
    this.lockScroll()

    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)

    fetch(url, { headers: { "X-Legal-Modal": "true" } })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const prose = doc.querySelector(".prose")
        if (prose) {
          this.contentTarget.innerHTML = prose.outerHTML
        } else {
          this.contentTarget.innerHTML = html
        }
      })
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.unlockScroll()
    if (this.boundKeydown) {
      document.removeEventListener("keydown", this.boundKeydown)
    }
  }

  clickOverlay(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  lockScroll() {
    this.savedScrollY = window.scrollY
    document.body.style.position = "fixed"
    document.body.style.top = `-${this.savedScrollY}px`
    document.body.style.left = "0"
    document.body.style.right = "0"
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.left = ""
    document.body.style.right = ""
    document.body.style.overflow = ""
    window.scrollTo(0, this.savedScrollY || 0)
  }
}
